import { cx } from 'cvb';
import PropTypes from 'prop-types';
import { Fragment } from 'react';
import AvailabilityDesktopDownloadable from '../../AvailabilityDesktopDownloadable';
import AvailabilityDesktopItem from '../../AvailabilityDesktopItem';
import { useAvailabilityDesktop } from '../hooks/useAvailabilityDesktop';
import { AvailabilityDesktopStyles } from './style';

const AvailabilityDesktop = ({ availabilityCommonProps }) => {
  const hookData = useAvailabilityDesktop(availabilityCommonProps);

  const { shouldRender, shouldShowDownloadable, processedAvailabilityList, getItemProps, hasTopSpecifications } =
    hookData;

  if (!shouldRender) {
    return null;
  }

  return (
    <div className="availability-desktop">
      <div
        className={cx('availability-desktop__container', {
          'availability-desktop__container--new-hd-options': !hasTopSpecifications,
        })}
      >
        {shouldShowDownloadable && (
          <div className="availability-desktop__downloadable">
            <AvailabilityDesktopDownloadable />
          </div>
        )}
        {processedAvailabilityList.map((item) => {
          const itemProps = getItemProps(item);

          return (
            <Fragment key={item.shippingOptionType}>
              <div className="availability-desktop__item">
                <AvailabilityDesktopItem {...itemProps} />
              </div>
            </Fragment>
          );
        })}
      </div>
      <style jsx>{AvailabilityDesktopStyles}</style>
    </div>
  );
};

AvailabilityDesktop.propTypes = {
  availabilityCommonProps: PropTypes.shape({
    availabilityList: PropTypes.arrayOf(PropTypes.object).isRequired,
    labelsData: PropTypes.object.isRequired,
    sizes: PropTypes.array,
    colorVariants: PropTypes.array,
    deliveryData: PropTypes.object,
    deliveryActions: PropTypes.object,
    selectedType: PropTypes.string,
    setSelectedType: PropTypes.func,
    textGenerated: PropTypes.object,
    deliveryErrors: PropTypes.object,
    productData: PropTypes.object.isRequired,
    variantData: PropTypes.object.isRequired,
    appCtxData: PropTypes.object.isRequired,
    selectedDeliveryOption: PropTypes.object.isRequired,
    setSelectedDeliveryOption: PropTypes.func.isRequired,
    zoneConfig: PropTypes.object.isRequired,
    setZoneConfig: PropTypes.func.isRequired,
    badgeItems: PropTypes.array,
  }).isRequired,
};

export default AvailabilityDesktop;
